import * as _ from 'lodash'
const FEEDBACK_ICONS = {
	success: 'ok',
	warning: 'warning-sign',
	error: 'remove',
}
const ICON_SPAN = '<span class="glyphicon form-control-feedback invisible"/>'

// Applies bootstrap validation feedback styles/icons to formgroup input

// See: http://getbootstrap.com/css/#with-optional-icons

interface FeedbackStatus {
	status?: string
	icon?: string
}
type Classifier = (val: string) => string | FeedbackStatus

class Feedback {
	private readonly input$: JQuery
	private readonly formGroup$: JQuery
	private readonly iconSpan$: JQuery

	constructor(formGroup: HTMLElement,
							private readonly classifier: Classifier = () => undefined,
							inputSelector?: string) {
		inputSelector = inputSelector || 'input.form-control'
		this.formGroup$ = $(formGroup)
		const input$ = this.formGroup$.find(inputSelector)
		if (input$.length === 0) {
			return
		} else {
			this.input$ = input$.first()
		}
		this.formGroup$.addClass('has-feedback')
		let anchor$
		if (this.formGroup$.hasClass('input-group')) {
			anchor$ = input$
		} else {
			const inputGroup$ = input$.parent('.input-group').first()
			anchor$ = inputGroup$.length > 0 ? inputGroup$ : input$
		}
		this.iconSpan$ = $(ICON_SPAN)
		this.iconSpan$.insertAfter(anchor$)
		input$.on('propertychange change click keyup input paste blur typeahead:autocompleted typeahead:selected', _.debounce(this.update.bind(this), 500))
	}

	update() {
		const curClass = this.classifier(this.input$.val())
		const feedback = typeof curClass === 'string' ? { status: curClass } : curClass
		const status = feedback?.status
		const hasFeedback = status != null
		this.formGroup$.removeClass((i, c) => (c.match(/has-\w+/g) || []).join(' '))
		this.formGroup$.toggleClass('has-feedback', hasFeedback)
		this.iconSpan$.removeClass((i, c) => (c.match(/glyphicon-\w+/g) || []).join(' '))
		this.iconSpan$.toggleClass('invisible', !hasFeedback)
		if (hasFeedback) {
			this.formGroup$.addClass('has-' + status)
			const icon = feedback?.icon || FEEDBACK_ICONS[status]
			this.iconSpan$.addClass('glyphicon-' + icon)
		}
		this.formGroup$.trigger('feedbackClassChanged', curClass)
	}
}
export default Feedback
